import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import reportWebVitals from './lib/reportWebVitals';

// Bundle optimization imports
import { registerServiceWorker, reportWebVitals as reportBundleVitals } from './utils/bundleOptimization';
import { safeConsole } from './utils/productionUtils';

// Disable browser scroll restoration to prevent auto-scroll on page reload/navigation
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Add loading class to prevent scrolling during load
document.documentElement.classList.add('loading');

// Initialize optimizations
const initializeOptimizations = async () => {
  safeConsole.log('🚀 Starting Bundle Optimization System...');
  
  // Register service worker (production only)
  if (process.env.NODE_ENV === 'production') {
    await registerServiceWorker();
  }
  
  // Report web vitals with enhanced metrics
  reportBundleVitals((metric) => {
    // Send metrics to analytics service
    if (process.env.NODE_ENV === 'production') {
      // Replace with your analytics endpoint
      safeConsole.log('Web Vital:', metric);
    }
  });
};

// Re-enable smooth scrolling after page loads
window.addEventListener('load', async () => {
  try {
    // Initialize optimizations
    await initializeOptimizations();
    
    setTimeout(() => {
      document.documentElement.classList.remove('loading');
      document.documentElement.classList.add('loaded');
    }, 1000); // Reduced to 1 second for better UX
  } catch (error) {
    safeConsole.error('Failed to initialize optimizations:', error);
    
    // Still remove loading state even if optimizations fail
    setTimeout(() => {
      document.documentElement.classList.remove('loading');
      document.documentElement.classList.add('loaded');
    }, 1000);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(safeConsole.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
